import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    fontWeight: '500',
    fontSize: '48px'
  }
});

const DateView = ({ displayDate }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <span>{displayDate.dayOfWeek}</span>
      <span>
        {displayDate.month} {displayDate.date}{' '}
      </span>
      <span style={{ fontSize: '28px', marginBottom: '16px' }}>
        {displayDate.time}
      </span>
    </div>
  );
};

export default DateView;
